// @ts-nocheck
import {restServices} from "../../../../cuba/services";
import {IParticipant} from "../ui";

interface IParams {
  searchValue?: string
  lang?: string
}
interface IParamsGet extends IParams{
  limit?: string
  offset?: string
  page?: number
  signal?: AbortSignal
  personGroupId?: string
}
export interface IParamsPost {
  data: {
    personGroupIds: string[]
    concourseRequestId: string
  }
}
interface IUserParams {
  lang?: string
  personGroupId: string
  membersCreateTs: string
}

const setOffset = (page?: number) => {
  if(page) return `${page - 1}`
  return "0"
}
export const getUser = async (params: IParamsGet): Promise<IParticipant[]> => {
    const {
      searchValue = '',
      lang = 'ru',
      page = 1,
      limit = '10'
    } = params
    try {
        return await restServices.employeeService.getfetch({
            lang: lang,
            expression: searchValue && searchValue.toLowerCase() || '',
            limit: limit,
            offset: setOffset(page),
            servicePath: 'tsadv_EmployeeService/searchPersonExtData',
        })
    } catch (e) {
      return []
    }
};
export const getUsersById = async (params: IUserParams): Promise<IParticipant[]> => {
  const {
    personGroupId,
    lang = 'ru',
    membersCreateTs
  } = params
  try {
    return await restServices.employeeService.getfetchUser({
      lang: lang,
      servicePath: 'tsadv_EmployeeService/searchPersonExtById',
      personGroupId,
      membersCreateTs
    })
  } catch (e) {
    return []
  }
};



export const getUserWithSignal = async (params: IParamsGet): Promise<IParticipant[]> => {
  const {
    searchValue = '',
    lang = 'ru',
    page = 1,
    limit = '10',
    signal = new AbortController().signal
  } = params
  try {
    return await restServices.employeeService.getfetchWithSignal({
      lang: lang,
      expression: searchValue && searchValue.toLowerCase() || '',
      limit: limit,
      offset: setOffset(page),
      servicePath: 'tsadv_EmployeeService/searchPersonExtData',
      signal
    })
  } catch (e) {
    return []
  }
};
export const getCount = async (params: IParams): Promise<number> => {
  return await restServices.employeeService.searchPersonExtCount({
    expression: params.searchValue && params.searchValue.toLowerCase() || '', lang: 'ru'
  }).then((res: number)=>{
    return res
  }).then((value=>{
    return value
  }))
}

export const saveParticipants = async (param: IParamsPost): Promise<number> => {
  const {data} = param
  return await restServices.employeeService.postFetch(data, 'tsadv_EmployeeService/saveConcourseRequestMembers')
}

export const checkParticipantsInclude = (selectedParticipants: IParticipant[], item?: IParticipant) => {
  if (!item) return false
  const arr = selectedParticipants.filter((elem) => elem.person_group_id === item.person_group_id)
  return !arr.length
}
